import React, { useState } from 'react';

const qaData = [
  {
    question: 'What skills can my child or I develop through Polonsky Academy’s online chess coaching?',
    answer: 'Our coaching focuses on critical thinking, problem-solving, strategic planning, pattern recognition, and patience. Students also develop resilience and good sportsmanship.'
  },
  {
    question: 'How are Polonsky Academy’s online chess lessons structured?',
    answer: 'Each lesson is tailored to the student\'s level and includes a mix of opening theory, middlegame strategy, endgame techniques, tactical puzzles, and analysis of famous games.'
  },
  {
    question: 'What makes Polonsky Academy’s chess coaching unique?',
    answer: 'Our uniqueness lies in our personalized approach. We match students with coaches who fit their learning style and goals, ensuring a supportive and effective learning environment.'
  },
  {
    question: 'Can my child participate in chess tournaments through Polonsky Academy?',
    answer: 'Yes, we actively encourage and help prepare our students for online and over-the-board tournaments suitable for their skill level.'
  },
  {
    question: 'Is Polonsky Academy beginner-friendly for players new to chess?',
    answer: 'Absolutely. We have dedicated programs for absolute beginners that start with the very basics of how the pieces move and build a strong foundation from the ground up.'
  },
  {
    question: 'Do you offer trial classes for new students?',
    answer: 'Yes, we offer a free trial class so you can experience our coaching style and see if the academy is the right fit for you before making a commitment.'
  },
  {
    question: 'How does Polonsky Academy support long-term chess development?',
    answer: 'We create a long-term development roadmap for our students, tracking their progress, adjusting their curriculum, and providing continuous support to help them achieve their chess ambitions.'
  }
];

const QA = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="qa-section">
      <div className="container">
        <h2 className="qa-title">Frequently asked questions</h2>
        <div className="qa-list">
          {qaData.map((item, index) => (
            <div className="qa-item" key={index}>
              <div className="qa-question" onClick={() => toggle(index)}>
                <span>{item.question}</span>
                <div className={`arrow-icon ${openIndex === index ? 'open' : ''}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </div>
              {openIndex === index && (
                <div className="qa-answer">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QA;
